module.exports = __webpack_public_path__ + "img/35_2.69f72664.png";